export enum SortOrder {
    Descending = 0,
    Ascending = 1,
}